export default "__VITE_ASSET__BrSyib2j__"